const SUPERVISOR_ASSIGNMENT_LIST =
  "fleet_monitoring.assignment_management.supervisor_assignment_list";

export const SUPERVISOR_ASSIGNMENTS_VIEW = `${SUPERVISOR_ASSIGNMENT_LIST}.view`;
export const SUPERVISOR_ASSIGNMENTS_CREATE = `${SUPERVISOR_ASSIGNMENT_LIST}.create`;
export const SUPERVISOR_ASSIGNMENTS_UPDATE = `${SUPERVISOR_ASSIGNMENT_LIST}.update`;
export const SUPERVISOR_ASSIGNMENTS_DELETE = `${SUPERVISOR_ASSIGNMENT_LIST}.delete`;

const ASSET_ASSIGNMENT_LIST =
  "fleet_monitoring.assignment_management.asset_assignment_list";

export const ASSET_ASSIGNMENTS_VIEW = `${ASSET_ASSIGNMENT_LIST}.view`;
// Assigning moves an asset between branches, so the API gates it on update.
export const ASSET_ASSIGNMENTS_UPDATE = `${ASSET_ASSIGNMENT_LIST}.update`;
export const ASSET_DRIVER_ASSIGNMENTS_VIEW =
  "fleet_monitoring.assignment_management.asset_driver_assignment_list.view";
export const ASSET_DRIVER_ASSIGNMENTS_CREATE =
  "fleet_monitoring.assignment_management.asset_driver_assignment_list.create";
export const ASSET_DRIVER_ASSIGNMENTS_UPDATE =
  "fleet_monitoring.assignment_management.asset_driver_assignment_list.update";
export const ASSET_DRIVER_ASSIGNMENTS_DELETE =
  "fleet_monitoring.assignment_management.asset_driver_assignment_list.delete";
export const LIVE_TRACKING_MAP_VIEW =
  "fleet_monitoring.tracking_management.live_tracking_map.view";
/** Live dashcam video (`POST /devices/:deviceId/video/live`), and talking to
 *  the camera's speaker (`POST /devices/:deviceId/video/intercom`): talk has no
 *  permission of its own. */
export const LIVE_VIDEO_VIEW = "fleet_monitoring.tracking_management.live_video.view";
/** Hearing the cab: a live stream started by a user with it carries sound.
 *  The server decides; the client only shows the sound when the stream has it. */
export const VIDEO_LISTEN_VIEW = "fleet_monitoring.tracking_management.video_listen.view";
/** A dashcam's recordings beside map playback (`.../video/recordings`,
 *  `.../video/playback`). */
export const VIDEO_PLAYBACK_VIEW = "fleet_monitoring.tracking_management.video_playback.view";
const POI_MANAGEMENT_LIST = "fleet_monitoring.tracking_management.poi_management_list";

/** The POI screen. TEMPORARY: view, update and delete follow create's segment
 *  by convention -- confirm them once the API has those endpoints. */
export const POI_VIEW = `${POI_MANAGEMENT_LIST}.view`;
/** Creating points of interest (`POST /pois`). */
export const POI_CREATE = `${POI_MANAGEMENT_LIST}.create`;
export const POI_UPDATE = `${POI_MANAGEMENT_LIST}.update`;
export const POI_DELETE = `${POI_MANAGEMENT_LIST}.delete`;
const GEOFENCE_MANAGEMENT_LIST =
  "fleet_monitoring.tracking_management.geofence_management_list";

/** The geofence screen: view, create, update and delete, as the API names them. */
export const GEOFENCE_VIEW = `${GEOFENCE_MANAGEMENT_LIST}.view`;
export const GEOFENCE_CREATE = `${GEOFENCE_MANAGEMENT_LIST}.create`;
export const GEOFENCE_UPDATE = `${GEOFENCE_MANAGEMENT_LIST}.update`;
export const GEOFENCE_DELETE = `${GEOFENCE_MANAGEMENT_LIST}.delete`;
/** TEMPORARY: core's Device Management lists, which the camera look-up goes
 *  through until the tracking vehicle carries its device and cameras (see
 *  CameraRepository.getVehicleCameras): the devices, then their models. */
export const DEVICE_LIST_VIEW = "core.device_management.device_management_list.view";
export const DEVICE_TYPE_LIST_VIEW = "core.device_management.device_type_management_list.view";
